
import {Component, Vue, Watch} from "vue-property-decorator";
import {getById} from "../api/artists";
import {IArtistJson} from "../../../server/src/modules/shared-interfaces";
import ArtistImage from "./ArtistImage.vue";

@Component({
    components: {ArtistImage}
})
export default class ArtistDetails extends Vue {

    loading = false;
    artist: IArtistJson | null = null;
    error: string | null = null;


    created() {
        this.fetch();
    }

    @Watch("$route")
    fetch() {
        this.error = this.artist = null;
        this.loading = true;
        const id = parseInt(this.$route.params['id'], 10);
        getById(id)
            .then(artist => this.artist = artist)
            .then(() => this.loading = false)
            .catch(reason => this.error = reason);
    }

}
